/*global chrome*/
import React from "react";
import { useParams } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Counter from "../../../../../../../components/counter";
import editIcon from "../../../../../../../images/edit-icon.png";
import infoIcon from "../../../../../../../images/info.png";
import refresh from "../../../../../../../images/training/refresh.png";
import sendwhite from "../../../../../../../images/training/send-white.png";
import saveimg from "../../../../../../../images/doc-input.png";
import playIcon from "../../../../../../../images/training/play.png";
import checkStatus from "../../../../../../../images/check-status.svg";
import closeStatus from "../../../../../../../images/close-status.svg";
import leftArrowIcon from "../../../../../../../images/left-arrow-back.svg";
import progressStatus from "../../../../../../../images/progress-status.svg";

import compareIcon from "../../../../../../../images/left-and-right-arrows.png";
import aggregateIcon from "../../../../../../../images/flowchart.png";
import {
  EditorState,
  ContentState,
  convertFromHTML,
  SelectionState,
  Modifier,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { stateToHTML } from "draft-js-export-html";
import htmlToDraft from "html-to-draftjs";
import imageIcon from "../../../../../../../images/image-pic.png";
import { ReactNotifications, Store } from "react-notifications-component";

import { PDFDownloadLink } from "@react-pdf/renderer";
import MyDocument from "../../../../../../../components/document";
import {
  updateFormatedData,
  publishHelperSkill,
  startRecord,
  stopRecord,
  getDraftSkillsById,
  getSession,
  toogleDataMapper,
  startTimer,
  setLoading,
  getAuthorDetail,
  createAuthorDetail,
  updateAuthorDetail,
  getDocument,
  setDraft,
  setReadOnly,
  createRevision,
  updateRevision,
} from "../../../../../../../redux/actions/skill";
import { getFileUrl } from "../../../../../../../redux/actions/fileUpload";

import { notify } from "../../../../../../../redux/actions/snack";
import TemplateName from "./TemplateName";
import { v4 as uuid } from "uuid";
import PlayModal from "./PlayModal";
import ShareComponent from "./ShareComponent";
import { Radio } from "antd";
import { Form, Button, Input, Select } from "antd";
import { desktopAgentExists } from "../../../../../../../utility/extension";
const { Option } = Select;
const FlowActionMenu = (props) => {
  const params = useParams();
  const [isEditingSkillName, setIsEditingSkillName] = useState(false);
  const [skillName, setSkillName] = useState("");
  const [isEditingSkillDesc, setIsEditingSkillDesc] = useState(false);
  const [isFlowActionsEnabled, setIsFlowActionEnabled] = useState(false);
  const [isFlowPublishing, setIsFlowPublishing] = useState("");
  const [isFlowPublishingSkillHub, setIsFlowPublishingSkillHub] = useState("");
  const [isSavingRevision, setIsSavingRevision] = useState(false);
  const [exportPdf, setExportPdf] = useState(false);
  const [excelSheetUrl, setExcelSheetUrl] = useState("");
  const [isSavingFlow, setIsSavingFlow] = useState(false);
  const [onboardUrl, setOnboardUrl] = useState(false);
  const [canPublish, setCanPublish] = useState(false);
  const [showAuthorForm, setShowAuthorForm] = useState(false);
  const [isNewEmail, setNewEmail] = useState(false);
  const [authorFirstName, setAuthorFirstName] = useState("");
  const [authorLastName, setAuthorLastName] = useState("");
  const [profilePic, setProfilePic] = useState("");
  const skill = useSelector((state) => state.skillReducer.trainDraft);
  const compareFlow = useSelector((state) => state.skillReducer.compareFlow);

  const currentTeam = useSelector(
    (state) => state.organizationReducer?.currentOrgUser?.organization_id
  );
  const userDeviceId = useSelector((state) => state.skillReducer.draftSession);
  const showMapper = useSelector(
    (state) => state.skillReducer.toogleDataMapper
  );
  const isRecord = useSelector((state) => state.skillReducer?.isRecording);
  const isTimerEnabled = useSelector((state) => state.skillReducer?.startTimer);
  const userRole = useSelector(
    (state) => state.organizationReducer?.currentOrganization
  );
  const userSub = useSelector((state) => state.userReducer?.user?.sub);
  const readOnly = useSelector((state) => state.skillReducer?.readOnly);
  const editorRef = useRef(null);

  const dispatch = useDispatch();
  const history = useHistory();
  const toolbarOptions = {
    options: ["inline", "blockType", "fontFamily", "list", "history"],
    inline: {
      options: ["bold", "italic", "underline"],
    },
    blockType: {
      options: ["Normal", "H1", "H2", "H3", "H4", "H5", "H6"],
    },
    fontFamily: {
      options: [
        "Arial",
        "Calibri",
        "Georgia",
        "Impact",
        "Tahoma",
        "Times New Roman",
        "Verdana",
      ],
    },
    list: {
      options: ["unordered", "ordered"],
    },
    history: {
      options: ["undo", "redo"],
    },
  };

  useEffect(() => {
    if (skill && skill.RAW_DATA?.actions?.length) {
      setIsFlowActionEnabled(true);
    } else {
      setIsFlowActionEnabled(false);
    }
  }, [skill?.RAW_DATA?.actions]);
  useEffect(() => {
    if (
      skill?.RAW_DATA?.excelData?.url &&
      skill?.RAW_DATA?.excelData?.sheetName
    ) {
      setExcelSheetUrl(skill?.RAW_DATA?.excelData?.url);
    }
  }, [skill?.RAW_DATA?.excelData]);

  useEffect(() => {
    if (skill?.onboarding_url == null) {
      setOnboardUrl(false);
    } else {
      setOnboardUrl(skill?.onboarding_url);
    }
  }, [skill?.onboarding_url]);

  useEffect(() => {
    if (skill) {
      checkAuthor();
    }
  }, [skill]);

  useEffect(() => {
    checkAuthorization();
    return () => {
      dispatch(setReadOnly(true));
    };
  }, [skill]);

  useEffect(() => {
    if (!window.eventAttached) {
      window.eventAttached = true;
      document.addEventListener("stopInitiated", onStopRecord);
      document.addEventListener("stopCompleted", onStopComplete);
      document.addEventListener("pause", onPause);
      document.addEventListener("resume", onResume);
    }
    return () => {
      window.eventAttached = false;
      document.removeEventListener("stopInitiated", onStopRecord);
      document.removeEventListener("stopCompleted", onStopComplete);
      document.removeEventListener("pause", onPause);
      document.removeEventListener("resume", onResume);
    };
  }, [skill]);

  const onPause = (e) => {
    console.log(e);
  };

  const onResume = (e) => {
    console.log(e);
  };

  const onStopComplete = () => {
    dispatch(getDraftSkillsById(params.id));
  };

  const checkAuthorization = () => {
    let _org = parseInt(skill?.organizationId);
    if (skill && userRole?.name !== "") {
      if (skill?.USER_ID === userSub) {
        dispatch(setReadOnly(false));

        return;
      } else if (
        (userRole?.role_id == "2" || userRole?.role_id == "3") &&
        _org == userRole?.id
      ) {
        dispatch(setReadOnly(false));
        return;
      } else if (_org != userRole?.id && skill?.status !== "approved") {
        dispatch(setDraft(null));
        // window.location.replace(
        //   `${process.env.REACT_APP_WEB_APP_URL}/dashboard/skills/unauthorised`
        // );
      }
    }
  };

  const checkAuthor = async () => {
    let _check = await dispatch(getAuthorDetail(skill?.USER_EMAIL));
    if (_check?.data?.data?.length > 0) {
      setShowAuthorForm(false);
    } else {
      setShowAuthorForm(true);
      setNewEmail(true);
    }
  };
  const onChangeFirstName = (e) => {
    setAuthorFirstName(e.target.value);
  };
  const onChangeLastName = (e) => {
    setAuthorLastName(e.target.value);
  };
  const updateImage = async (file) => {
    let url = await dispatch(getFileUrl(file));
    setProfilePic(url);
  };

  let authorData;
  const onClickNextModal = (e) => {
    if (authorFirstName?.length > 0 && authorLastName?.length > 0) {
      setShowAuthorForm(false);
    } else dispatch(notify("error", "Please enter valid first and last name."));
  };

  const changeSkillName = (name) => {
    setIsEditingSkillName(false);
    const updateName = { itemId: skill.id, skillName: name };
    const res = dispatch(updateFormatedData(updateName));
  };

  const changeSkillDescription = (description) => {
    setIsEditingSkillDesc(false);
    const updateName = { itemId: skill.id, skillDescription: description };
    const res = dispatch(updateFormatedData(updateName));
  };

  const onEditorBlur = () => {
    const contentState = editorState.getCurrentContent();
    const blocks = contentState.getBlockMap();
    const fontFamilies = [
      "Arial",
      "Calibri",
      "Georgia",
      "Impact",
      "Tahoma",
      "Times New Roman",
      "Verdana",
    ];
    let fontFamiliesString = "";
    let description = stateToHTML(contentState);

    blocks.forEach((block) => {
      const inlineStyles = block.getInlineStyleAt(0);
      const fontFamilyStyle = inlineStyles.find(
        (style) =>
          style.startsWith("fontfamily-") || fontFamilies.includes(style)
      );

      if (fontFamilyStyle) {
        const fontFamily = fontFamilyStyle.replace("fontfamily-", "");
        if (fontFamilies.includes(fontFamily)) {
          fontFamiliesString = fontFamily;
          description = `<span style="font-family: ${fontFamily}">${description}</span>`;
        }
      }
    });

    changeSkillDescription(description);
  };

  const publishSkill = async (data) => {
    if (onboardUrl === null) {
      dispatch(notify("error", "Please select option"));
    } else {
      setIsFlowPublishingSkillHub(true);

      if (data.status !== null) {
        if (isNewEmail) {
          if (authorFirstName == "" || authorLastName == "") {
            dispatch(
              notify("error", "Please enter your firstname & lastname.")
            );
            setIsFlowPublishingSkillHub(false);

            return;
          } else {
            authorData = {
              first_name: authorFirstName,
              last_name: authorLastName,
              email: skill?.USER_EMAIL,
              profile_picture: profilePic || null,
              role: userRole?.role_id,
            };

            await dispatch(createAuthorDetail(authorData));

            const publishHelper = await dispatch(
              updateFormatedData({
                itemId: skill.id,
                status: "pending",
                TYPE: "SkillHub",
                onboarding_url: onboardUrl,
              })
            );
            setIsFlowPublishingSkillHub(false);

            dispatch(notify("success", "Success!"));
            history.push(window.location.path);
          }
        } else {
          authorData = {
            first_name: authorFirstName,
            last_name: authorLastName,
            email: skill?.USER_EMAIL,
            profile_picture: profilePic || null,
            role: userRole?.role_id,
          };

          await dispatch(updateAuthorDetail(authorData));
          const publishHelper = await dispatch(
            updateFormatedData({
              itemId: skill.id,
              status: "pending",
              TYPE: "SkillHub",
              onboarding_url: onboardUrl,
            })
          );
          setIsFlowPublishingSkillHub(false);

          dispatch(notify("success", "Success!"));
          history.push(window.location.path);
        }
      } else {
        setIsFlowPublishingSkillHub(false);
        dispatch(notify("error", "Already Published!"));
      }
    }
  };

  const publishTemplate = async (itemId) => {
    setIsFlowPublishing(true);
    // var rawData;
    // rawData = {
    //   ...skill?.RAW_DATA,
    //   actions: skill?.RAW_DATA?.actions,
    // };

    let status = "published";

    let skillName = skill?.SKILL_NAME;
    let updatedData = { status, skillName, itemId };
    const updateHelper = await dispatch(updateFormatedData(updatedData));

    if (updateHelper) {
      setIsFlowPublishing(false);

      dispatch(notify("success", " Updated and published successfully!"));
      history.push(window.location.path);
    } else {
      setIsFlowPublishing(false);

      dispatch(notify("error", "Something went wrong. Update failed."));
    }
  };

  const checkChromeExtension = (skillId, nodeId = null) => {
    try {
      chrome.runtime.sendMessage(
        process.env.REACT_APP_CHROME_TAB_ID,
        { type: "ping" },
        (response) => {
          if (!response) {
            notificationPopUp();
          } else {
            // startTimerRec(skillId, nodeId);
            reTrain(skillId, nodeId);
          }
        }
      );
    } catch (error) {
      notificationPopUp();
      console.log("error ", error);
    }
  };

  const notificationPopUp = () => {
    Store.addNotification({
      title: "Note: ",
      message:
        "Ohh! Seems you don't have Super browser extension added to your browser. Please add it before creating/using skills.",
      type: "warning",
      insert: "top",
      container: "top-right",
      dismiss: {
        duration: 5000,
        onScreen: true,
      },
    });
    window.setTimeout(function () {
      window.open(
        `https://chrome.google.com/webstore/detail/techforce-ide-extension/${process.env.REACT_APP_CHROME_TAB_ID}`,
        "_blank"
      );
    }, 5000);
  };

  const startTimerRec = async (skillId, nodeId = null) => {
    dispatch(startTimer(true));
    // setStartTimer(true);
    dispatch(notify("success", "Please wait for the Show process to start."));
    setTimeout(() => {
      reTrain(skillId, nodeId);
    }, 5000);
  };

  const reTrain = async (skillId, nodeId = null) => {
    dispatch(startTimer(true));

    let markerIndex = 0;

    let data = { skillId, markerIndex, nodeId };
    const startData = await dispatch(startRecord(data));
  };

  const onStopRecord = async () => {
    // setStartTimer(false);
    dispatch(setLoading(true));
    dispatch(startTimer(false));
    let data;
    if (skill?.TEMPLATE === "Process Discovery") {
      data = {
        deviceId: userDeviceId,
        skillId: skill.id,
        nodeId: isRecord?.nodeId,
        variantId: skill?.revision,
      };
    } else {
      data = {
        deviceId: userDeviceId,
        skillId: skill.id,
        nodeId: isRecord?.nodeId,
      };
    }
    // Testing stop event recording

    const stopData = await dispatch(stopRecord(data));
    const checkDesktopAgent = await desktopAgentExists();
    if (!checkDesktopAgent?.desktopAgentExists) {
      setTimeout(() => {
        dispatch(getDraftSkillsById(params.id));
      }, 8000);
    }
  };

  const delay = (duration) =>
    new Promise((resolve) => setTimeout(resolve, duration));

  const saveDraft = async () => {
    setIsSavingFlow(true);
    try {
      let updatedData;
      var rawData;
      var TYPE;
      var itemId = skill?.id;
      rawData = {
        ...skill?.RAW_DATA,
        actions: skill?.RAW_DATA?.actions,
      };
      var status;
      if (skill?.status === "approved" || skill?.status === "pending") {
        status = "pending";
        TYPE = "SkillHub";
      } else {
        status = skill?.status;
        TYPE = "regularSkill";
      }
      let skillName = skill?.SKILL_NAME;
      if (skill?.TEMPLATE === "Process Discovery") {
        updatedData = {
          status,
          skillName,
          rawData,
          itemId,
          TYPE,
          variantId: skill?.revision,
        };
      } else {
        updatedData = { status, skillName, rawData, itemId, TYPE };
      }
      const updateHelper = await dispatch(updateFormatedData(updatedData));

      if (updateHelper.success === false) {
        setIsSavingFlow(false);
        const errorMessage = updateHelper.error || "Failed to update!";
        dispatch(notify("error", errorMessage));
      } else if (updateHelper.success === true) {
        setIsSavingFlow(false);
        dispatch(notify("success", "Updated Succesfully!"));
      }
    } catch (err) {
      setIsSavingFlow(false);

      dispatch(notify("error", "Failed to update!"));
    }
  };

  const onRadioChange = (e) => {
    setOnboardUrl(e.target.value);
  };

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
  };

  const removeHtmlTags = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    let text = tempDiv.textContent || tempDiv.innerText || "";
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  const sanitizedDescription = removeHtmlTags(skill.SKILL_DESCRIPTION);

  const [editorState, setEditorState] = useState(() => {
    const contentBlocks = convertFromHTML(sanitizedDescription);
    const contentState = ContentState.createFromBlockArray(contentBlocks);
    return EditorState.createWithContent(contentState);
  });

  useEffect(() => {
    const contentBlocks = htmlToDraft(sanitizedDescription);
    const contentState = ContentState.createFromBlockArray(contentBlocks);

    const hasUnderline = sanitizedDescription.includes("<u>");

    if (hasUnderline) {
      const selection = new SelectionState({
        anchorKey: contentState.getFirstBlock().getKey(),
        anchorOffset: 0,
        focusKey: contentState.getLastBlock().getKey(),
        focusOffset: contentState.getLastBlock().getText().length,
      });
      const contentStateWithUnderline = Modifier.applyInlineStyle(
        contentState,
        selection,
        "UNDERLINE"
      );
      setEditorState(EditorState.createWithContent(contentStateWithUnderline));
    } else {
      setEditorState(EditorState.createWithContent(contentState));
    }

    return () => {
      setSkillName("");
      setEditorState(EditorState.createEmpty());
    };
  }, [sanitizedDescription]);

  useEffect(() => {
    window.$('[data-toggle="popover"]').popover({
      container: "body",
    });
  });

  const getPdf = async (id, skillName) => {
    setExportPdf(true);
    let query = { id: id, skillName: skillName };
    let result = await dispatch(getDocument(query));
    setExportPdf(false);
  };

  const backToggle = () => {
    history.goBack();
  };
  const displayRevision = () => {
    return (
      <React.Fragment>
        {skill.TEMPLATE === "Process Discovery" ? (
          <>
            {isSavingRevision ? (
              <button className="sm-btn">
                <div class="sp sp-circle text-light"></div>
              </button>
            ) : (
              <>
                <button
                  className="sm-btn"
                  disabled={isFlowActionsEnabled ? "" : "disabled"}
                  onClick={() => saveDraft()}
                >
                  <img src={saveimg} alt="" />

                  <span>Save</span>
                </button>
              </>
            )}
          </>
        ) : null}
      </React.Fragment>
    );
  };

  const checkCompareParams = () => {
    if (compareFlow?.length >= 2) {
      history.push("/dashboard/skills/compare-process");
    } else {
      dispatch(notify("info", "Please check any two varaints to compare "));
    }
  };

  const checkAggParams = () => {
    if (compareFlow?.length >= 2) {
      history.push("/dashboard/skills/aggregate-process");
    } else {
      dispatch(notify("info", "Please check any two varaints to aggregate "));
    }
  };

  const createVariant = async () => {
    let data = {
      document: skill?.RAW_DATA,
      documentId: skill?.id,
    };
    let _saveRevision = await dispatch(createRevision(data));
  };
  return (
    <React.Fragment>
      <div className="flex-title rt-flex-title">
        <div className="cts-title">
          {/* SKILL initials */}
          <button
            className="btn btn-outline cts-btn-back"
            onClick={() => backToggle()}
          >
            <img src={leftArrowIcon} />
          </button>
          <div className="cts-ico">
            <span>
              {skill?.SKILL_NAME
                ? skill?.SKILL_NAME?.toUpperCase().charAt(0)
                : null}
            </span>
          </div>

          {/* Skill Name */}

          <div className="cts-title-subt">
            <div class="title-edit-skill">
              <div className="cts-title-text">
                {isEditingSkillName ? (
                  <input
                    name="skillName"
                    placeholder="Enter Skill Name"
                    defaultValue={skill?.SKILL_NAME}
                    onBlur={(e) => changeSkillName(e.target.value)}
                  ></input>
                ) : (
                  <p>{skill?.SKILL_NAME}</p>
                )}
                {readOnly == true ? null : (
                  <div
                    className="edit-info-btns"
                    tooltip="edit skill name"
                    onClick={(e) => setIsEditingSkillName(true)}
                  >
                    <button className="edit-icon">
                      <img src={editIcon} />
                    </button>
                  </div>
                )}
              </div>
              <div className="cts-desc-text">
                {isEditingSkillDesc ? (
                  <div className="RichEditor-root">
                    <Editor
                      ref={editorRef}
                      spellCheck={false}
                      toolbarOnFocus={false}
                      editorState={editorState}
                      wrapperClassName="demo-wrapper"
                      editorClassName="demo-editor"
                      placeholder="Enter Description"
                      onEditorStateChange={onEditorStateChange}
                      onBlur={onEditorBlur}
                      toolbar={toolbarOptions}
                    />
                  </div>
                ) : (
                  <div
                    className="cts-desc-text-hidden"
                    dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                  ></div>
                )}
                {readOnly == true ? null : (
                  <div
                    className="edit-info-btns"
                    onClick={(e) => setIsEditingSkillDesc(true)}
                  >
                    <button
                      data-toggle="popover"
                      data-html="true"
                      data-trigger="hover"
                      data-placement="bottom"
                      data-content={sanitizedDescription}
                      className="info-icon"
                    >
                      <img src={infoIcon} />
                    </button>
                    <button className="edit-icon">
                      <img src={editIcon} />
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* Template Name */}
            {<TemplateName {...skill} />}
          </div>
        </div>

        {/* Template options  */}
        <div className="rt-btns">
          {/* ---------Share Option----------- */}
          <ShareComponent />
          {/* ---------Play option---------- */}

          <PlayModal />

          {/* Compare button for Process Discovery */}

          {skill?.TEMPLATE === "Process Discovery" &&
          userRole?.role_id == "2" ? (
            <>
              <button className="sm-btn" onClick={() => checkAggParams()}>
                <img src={aggregateIcon} alt="" style={{ width: "18px" }} />

                <span>Aggregate</span>
              </button>
              <button className="sm-btn" onClick={() => checkCompareParams()}>
                <img src={compareIcon} alt="" style={{ width: "18px" }} />

                <span>Compare</span>
              </button>
            </>
          ) : null}

          {/* show new variant  process discovery*/}
          {skill?.TEMPLATE === "Process Discovery" ? (
            <>
              <button
                className="sm-btn"
                onClick={() => {
                  checkChromeExtension(skill.id);
                }}
                disabled={isRecord.status === true ? "disabled" : null}
              >
                <img src={refresh} alt="" />
                <span>Start Show</span>
              </button>
            </>
          ) : null}

          {/* Play with Dropdown */}
          {/* <div className="device-dropdown dropdown">
            <button
              className="sm-btn play-btn"
              type="button"
              data-toggle="dropdown"
            >
              <img src={playIcon} alt="" />
              <span>Play</span>
            </button>
            <div className="dropdown-menu">
              <ul class="list-group">
                {devices.length > 0 ? (
                  devices.map((i, index) => {
                    return (
                      <li class="list-group-item" key={index}>
                        <div className="dc-list">
                          <div className="dc-label">
                            <div className="dc-icon">
                              <img src={deviceIcon} />
                            </div>
                            <div className="dc-text">
                              <p>DESKTOP-J98CEEH</p>
                              <span>Arvind Patel</span>
                            </div>
                          </div>
                          <div className="check-dc selected">
                            <img src={checkIcon} />
                          </div>
                        </div>
                      </li>
                    );
                  })
                ) : (
                  <li class="list-group-item">
                     No linked devices found
                  </li>
                )}
              </ul>
            </div>
          </div> */}

          {/* Save button */}
          {!process.env.REACT_APP_TEMPLATES_DISABLE_UPDATE.includes(
            skill?.id
          ) ? (
            <>
              {isSavingFlow ? (
                <button className="sm-btn">
                  <div class="sp sp-circle text-light"></div>
                </button>
              ) : (
                <>
                  {readOnly == true ? null : (
                    <>
                      {skill?.TEMPLATE === "Process Discovery" ? (
                        <>{displayRevision()}</>
                      ) : (
                        <button
                          className="sm-btn"
                          disabled={isFlowActionsEnabled ? "" : "disabled"}
                          onClick={() => saveDraft()}
                        >
                          <img src={saveimg} alt="" />

                          <span>Save</span>
                        </button>
                      )}
                    </>
                  )}
                </>
              )}
              {/* {displayRevision()} */}
            </>
          ) : null}

          {/* ----------Retrain option---------- */}

          {skill?.organizationId == currentTeam ? (
            <React.Fragment>
              {readOnly == true ? null : (
                <>
                  {[
                    "UserDocumentation",
                    "In-App Walkthrough"
                  ].includes(skill?.TEMPLATE) ? (
                    <React.Fragment>
                      {skill?.RAW_DATA?.actions?.length > 0 && (
                        <button
                          className="sm-btn"
                          data-toggle="modal"
                          data-target="#mySkillRetrainModal"
                          disabled={
                            isRecord.status === true ? "disabled" : null
                          }
                        >
                          <img src={refresh} alt="" />
                          <span>Reshow</span>
                        </button>
                      )}
                      {skill?.RAW_DATA?.actions?.length === 0 && (
                        <button
                          className="sm-btn"
                          onClick={() => {
                            checkChromeExtension(skill.id);
                          }}
                          disabled={
                            isRecord.status === true ? "disabled" : null
                          }
                        >
                          <img src={refresh} alt="" />
                          <span>Show</span>
                        </button>
                      )}
                    </React.Fragment>
                  ) : null}
                </>
              )}

              {/* -------Start Recording option------- */}
              {isTimerEnabled === true ? (
                <>
                  <button
                    className="btn btn-danger btn-sm btn-stop-train"
                    style={{
                      backgroundColor: "#ff3333",
                      color: "#fff",
                      borderColor: "#ff3333",
                      borderRadius: "3px",
                    }}
                    onClick={(e) => onStopRecord()}
                  >
                    {isRecord.status === true ? <span>Stop Show</span> : null}
                  </button>
                </>
              ) : null}

              {/* -------Publish User Documentation------------- */}
              {/* {["UserDocumentation", "WebAutomation", "Automation"].includes(
            skill.TEMPLATE
          ) ? (
           
          ) : null} */}

              {/* <React.Fragment>
                {userRole === "1" ? null : (
                  <>
                    {skill?.status === "published" ? (
                      <>
                        <button className="sm-btn" disabled={"disable"}>
                          <img src={saveimg} alt="" />

                          <span>Published</span>
                        </button>
                      </>
                    ) : (
                      <>
                        {isFlowPublishing ? (
                          <button className="sm-btn">
                            <div class="sp sp-circle text-light"></div>
                          </button>
                        ) : (
                          <button
                            className="sm-btn"
                            disabled={isFlowActionsEnabled ? "" : "disable"}
                            onClick={() => publishTemplate(skill.id)}
                          >
                            <img src={saveimg} alt="" />

                            <span>Publish</span>
                          </button>
                        )}
                      </>
                    )}
                  </>
                )}
              </React.Fragment> */}

              {/* -------Pdf Download option----------- */}
              {["UserDocumentation", "In-App Walkthrough"].includes(
                skill?.TEMPLATE
              ) && (
                <>
                  {isFlowActionsEnabled ? (
                    <div class="dropdown publish-dropdown export-dropdown">
                      <button
                        class="sm-btn"
                        type="button"
                        data-toggle="dropdown"
                      >
                        {exportPdf ? (
                          <div class="sp sp-circle text-light"></div>
                        ) : (
                          <>
                            <img
                              src={sendwhite}
                              style={{ filter: "invert(1)" }}
                              alt=""
                            />
                            <span>Export As</span>
                          </>
                        )}
                      </button>
                      <ul class="dropdown-menu">
                        <li>
                          {skill?.status === "approved" ? (
                            <a
                              href={`${process.env.REACT_APP_BOT_SERVICE_URL}/document?id=${skill.id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              HTML URL
                            </a>
                          ) : (
                            <a
                              href={`${process.env.REACT_APP_BOT_SERVICE_URL}/viewDocument?id=${skill.id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              HTML URL
                            </a>
                          )}
                        </li>
                        <li>
                          <a
                            // href={`${process.env.REACT_APP_BOT_SERVICE_URL}/downloadPdf?id=${skill.id}`}
                            onClick={(e) => {
                              getPdf(skill.id, skill.SKILL_NAME);
                            }}
                          >
                            Dowload Pdf
                          </a>
                        </li>
                      </ul>
                    </div>
                  ) : (
                    <button
                      className="sm-btn"
                      disabled
                      style={{ cursor: "not-allowed" }}
                    >
                      <img
                        src={sendwhite}
                        style={{ filter: "invert(1)" }}
                        alt=""
                      />
                      <span>Export As</span>
                    </button>
                  )}
                </>
              )}
              {/* ------Publish option for in app walkthrough-------- */}

              {readOnly == true ? null : (
                <>
                  {" "}
                  {["UserDocumentation", "Process Discovery"].includes(
                    skill.TEMPLATE
                  ) ? null : (
                    <React.Fragment>
                      <React.Fragment>
                        {isFlowPublishingSkillHub ? (
                          <button className="btn btn-approve">
                            {" "}
                            <div class="sp sp-circle text-light"></div>
                          </button>
                        ) : (
                          <React.Fragment>
                            <div class="dropdown publish-dropdown export-dropdown">
                              <button className="sm-btn" data-toggle="dropdown">
                                {isFlowPublishing ? (
                                  <>
                                    {" "}
                                    <div class="sp sp-circle text-light"></div>
                                  </>
                                ) : (
                                  <>
                                    <img src={saveimg} alt="" />

                                    <span>Publish</span>
                                  </>
                                )}
                              </button>
                              <ul class="dropdown-menu dropdown-menu-right">
                                <li
                                  class={
                                    skill?.status === "approved"
                                      ? "disabled"
                                      : ""
                                  }
                                >
                                  {/* {skill?.status === "approved" ? (
                                    <a>To Team</a>
                                  ) : (
                                    <a
                                      onClick={() => publishTemplate(skill?.id)}
                                    >
                                      To Team
                                    </a>
                                  )} */}
                                </li>
                                <li
                                  class={isFlowActionsEnabled ? "" : "disabled"}
                                >
                                  {isFlowActionsEnabled ? (
                                    <a
                                      data-toggle="modal"
                                      data-target="#publishModal"
                                    >
                                      To AI Agents Hub
                                    </a>
                                  ) : (
                                    <a>To AI Agents Hub</a>
                                  )}
                                </li>
                              </ul>
                            </div>
                          </React.Fragment>
                        )}

                        {/* -------------------------SKILL STATUS---------------------> */}
                        {skill.status !== "self" ? (
                          <React.Fragment>
                            <div className="publish-status">
                              <div
                                className={
                                  skill?.status === "published"
                                    ? "status-success"
                                    : "status-success hidden"
                                }
                              >
                                <fieldset>
                                  <legend>Success</legend>
                                  <div className="status-p">
                                    <div
                                      className="stp-icon"
                                      style={{ backgroundColor: "#c9fff0" }}
                                    >
                                      <img src={checkStatus} />
                                    </div>
                                    <p>Published To Team</p>
                                  </div>
                                </fieldset>
                              </div>
                              <div
                                className={
                                  skill?.status === "approved"
                                    ? "status-success"
                                    : "status-success hidden"
                                }
                              >
                                <fieldset>
                                  <legend>Published to AI Agent Hub</legend>
                                  <div className="status-p">
                                    <div
                                      className="stp-icon"
                                      style={{ backgroundColor: "#c9fff0" }}
                                    >
                                      <img src={checkStatus} />
                                    </div>
                                    <p>Approved</p>
                                  </div>
                                </fieldset>
                              </div>
                              <div
                                className={
                                  skill?.status === "declined"
                                    ? "status-error"
                                    : "status-error hidden"
                                }
                              >
                                <fieldset>
                                <legend>Published to AI Agent Hub</legend>
                                <div className="status-p">
                                    <div
                                      className="stp-icon"
                                      style={{ backgroundColor: "#ffebeb" }}
                                    >
                                      <img src={closeStatus} />
                                    </div>
                                    <p>Declined</p>
                                  </div>
                                </fieldset>
                              </div>
                              <div
                                className={
                                  skill?.status === "pending"
                                    ? "status-progress"
                                    : "status-progress hidden"
                                }
                              >
                                <fieldset>
                                <legend>Published to AI Agent Hub</legend>
                                <div className="status-p">
                                    <div
                                      className="stp-icon"
                                      style={{ backgroundColor: "#d0e4ff" }}
                                    >
                                      <img src={progressStatus} />
                                    </div>
                                    <p>Waiting for approval</p>
                                  </div>
                                </fieldset>
                              </div>
                            </div>
                          </React.Fragment>
                        ) : null}
                      </React.Fragment>
                    </React.Fragment>
                  )}
                </>
              )}
            </React.Fragment>
          ) : null}

          {/* ---------Mapper Option---------- */}
          {/* Moved inside for-loop action block */}
          {/* {skill.TEMPLATE === "Import Data from Spreadsheet to Web App" ? (
            <React.Fragment>
              <button
                data-toggle="modal"
                data-target={
                  !excelSheetUrl ? "#myRpaMapModal" : "#myRpaMapModalExcel"
                }
                className="sm-btn"
                disabled={
                  skill && skill.RAW_DATA && skill.RAW_DATA.actions
                    ? ""
                    : "disable"
                }
                onClick={() =>
                  dispatch(toogleDataMapper(showMapper == true ? false : true))
                }
              >
                <img src={refresh} alt="" />
                <span>Mapper</span>
              </button>
            </React.Fragment>
          ) : null} */}
        </div>
      </div>

      {/* Retrain Modal */}

      <div
        className="modal fade crt-skill"
        id="mySkillRetrainModal"
        role="dialog"
      >
        <div className="modal-dialog modal-sm">
          <div className="modal-content crt-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
              <h4 className="modal-title">Reshow Skill</h4>
            </div>
            <div className="modal-body">
              <div className="form-contain">
                <div className="frm-block">
                  <p className="md-text">
                    Reshow removes all the steps in the agent and starts
                    capturing steps from the beginning. Do you want to proceed?
                  </p>
                </div>
                <div className="frm-btns">
                  <button className="btn-primary" data-dismiss="modal">
                    Cancel
                  </button>
                  <button
                    className="primary-btn"
                    data-dismiss="modal"
                    onClick={() => {
                      checkChromeExtension(skill.id);
                    }}
                  >
                    {skill?.RAW_DATA?.actions ? "Proceed" : "Start Show"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="publishModal"
        class="modal fade crt-skill"
        role="dialog"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div class="modal-dialog ">
          <div class="modal-content crt-content ">
            <div className="modal-header">
              <h4 className="modal-title">Publish To AI Agents Hub </h4>

              <button type="button" class="close" data-dismiss="modal">
                ×
              </button>
            </div>

            <div class="modal-body">
              {showAuthorForm ? (
                <>
                  <Form>
                    <Form.Item
                      name="first_name"
                      label="First Name"
                      rules={[{ required: true }]}
                      onChange={onChangeFirstName}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      name="last_name"
                      label="Last Name"
                      rules={[{ required: true }]}
                      onChange={onChangeLastName}
                    >
                      <Input />
                    </Form.Item>
                    <div className="text-center">
                      <button
                        className="btn btn-primary"
                        onClick={onClickNextModal}
                      >
                        Next
                      </button>
                    </div>
                  </Form>
                </>
              ) : null}
              {!showAuthorForm ? (
                <div className="form-contain text-center">
                  <p>
                    {" "}
                    Prompt user for the application URL during agent onboarding?
                  </p>
                  <div className="flex-social">
                    <div style={{ marginBottom: "15px" }}>
                      <Radio.Group
                        onChange={onRadioChange}
                        defaultValue={
                          skill?.onboarding_url
                            ? skill.onboarding_url
                            : onboardUrl
                        }
                      >
                        <Radio value={true}>Yes</Radio>
                        <Radio value={false}>No</Radio>
                      </Radio.Group>
                    </div>
                  </div>

                  <div>
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        publishSkill(skill);
                      }}
                      data-dismiss="modal"
                    >
                      Publish
                    </button>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default FlowActionMenu;
